const getEnv = (key) => {
    // Priority 1: Docker runtime env (window.__APP_ENV__ from env.js)
    if (
      typeof window !== 'undefined' &&
      window.__APP_ENV__ &&
      window.__APP_ENV__[key] !== undefined &&
      window.__APP_ENV__[key] !== '' // ต้องมีค่าจริงๆ ไม่ใช่ empty string
    ) {
      return window.__APP_ENV__[key];
    }
    // Priority 2: Local development env (process.env from .env file)
    return process.env[key];
  };

const proxy = {
    main: getEnv('REACT_APP_API_MAIN') || "http://localhost:3113/",
    develop: getEnv('REACT_APP_API_DEVELOP') || "http://localhost:3042",
    server: getEnv('REACT_APP_API_SERVER') || "http://localhost:3113",
}

module.exports = {
    proxy: proxy,
}
